import { SectionContentWrapper } from "@/frontend/widgets/SectionContentWrapper/SectionContentWrapper";
import styles from "./MarketOverviewByAi.module.scss";
import { CheckIcon } from "@/frontend/shared/assets/icons";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { Typography } from "@/frontend/shared/ui/Typography";
import { UnlockIcon } from "@/frontend/shared/assets/icons/UnlockIcon";
import { EAccessDataStatus } from "@/frontend/features/Company/model/types/types";
import { NoAiDataContainer } from "@/frontend/features/Company/ui/NoAiDataContainer/NoAiDataContainer";
import { marketOverviewSectionDescription } from "../../../const/mock";
import { SectionLoader } from "../../Section/SectionLoader/SectionLoader";

export type TMarketOverviewByAiProps = {
  dataStatusFromAccess: EAccessDataStatus;
  onConfirmRequestDataAccess?: () => void;
  isLoadingRequestAccess?: boolean;
  logoUrl?: string | null;
  companyName?: string | null;
  aiProvidedDescription?: string;
  isLoadingAiProvidedDescription: boolean;
  onEdit?: () => void;
};

export function MarketOverviewByAi({
  dataStatusFromAccess,
  onConfirmRequestDataAccess,
  isLoadingRequestAccess,
  logoUrl,
  companyName,
  aiProvidedDescription,
  isLoadingAiProvidedDescription: isLoading,
  onEdit
}: TMarketOverviewByAiProps) {
  function aiProvidedDescriptionContent() {
    if (
      dataStatusFromAccess === EAccessDataStatus.FULL_DATA ||
      dataStatusFromAccess === EAccessDataStatus.PROFILE_DATA ||
      dataStatusFromAccess === EAccessDataStatus.NO_FOUNDER ||
      (!!aiProvidedDescription && aiProvidedDescription?.length > 0) ||
      isLoading
    ) {
      switch (true) {
        case !!aiProvidedDescription && aiProvidedDescription?.length > 0:
          return (
            <div className={styles.innoveraWhiteBlock}>
              <Typography variant="body-2" color="greyscale900">
                {aiProvidedDescription}
              </Typography>
            </div>
          );
        case isLoading:
          return <SectionLoader />;
        case !aiProvidedDescription || aiProvidedDescription?.length === 0:
          return <NoAiDataContainer section="Market" name={companyName || "Company"} onAddDataClick={onEdit} />;
        default:
          return null;
      }
    }
    if (dataStatusFromAccess === EAccessDataStatus.NO_ACCESS) {
      return (
        <div className={styles.innoveraWhiteBlock}>
          <Typography variant="body-2" color="greyscale700">
            {marketOverviewSectionDescription}
          </Typography>
          <div className={styles.innoveraWhiteBlockNoAccess}>
            <NormalButton
              variant="primary"
              size="medium"
              className={styles.requestButton}
              onClick={onConfirmRequestDataAccess}
              isSubmitting={isLoadingRequestAccess}
            >
              <UnlockIcon />
              <Typography variant="label-4" color="greyscale100">
                Request Data Access
              </Typography>
            </NormalButton>
          </div>
        </div>
      );
    }
    if (dataStatusFromAccess === EAccessDataStatus.PENDING_REQUEST) {
      return (
        <div className={styles.innoveraWhiteBlock}>
          <Typography variant="body-2" color="greyscale700">
            {marketOverviewSectionDescription}
          </Typography>
          <div className={styles.innoveraWhiteBlockNoAccess}>
            <NormalButton variant="primary" size="medium" className={styles.requestButtonSent}>
              <CheckIcon />
              <Typography variant="label-4" color="greyscale100">
                Access Request Sent
              </Typography>
            </NormalButton>
          </div>
        </div>
      );
    }

    return null;
  }

  return (
    <SectionContentWrapper isByInnovera={false} companyName={companyName} companyLogoSrc={logoUrl}>
      {aiProvidedDescriptionContent()}
    </SectionContentWrapper>
  );
}
